export default "__VITE_ASSET__DqjR$NMX__"